export default __webpack_public_path__ + "static/media/HDTX_Buyback_scripless_English 2025.25eb32e5.pdf";